import React from 'react'

const BottomRightButton = ({onClick, name,className=""}) => {
    return (
        <button
            type="submit"
            className={`all_bottom_buttons d-block ml-auto ${className}`}
            onClick={onClick}
        >
            {name}
        </button>
    )
}
export default BottomRightButton